<template>
  <div v-if="type === 'video'">
    <vue-plyr>
      <div data-plyr-provider="youtube"
           :data-plyr-embed-id="videoId"
           data-plyr-config='{"youtube": {"hl": "ar"}}'
      ></div>
    </vue-plyr>
  </div>
</template>

<script>
import VuePlyr from 'vue-plyr'

import {
  Player,
  Youtube,
  Ui,
  LoadingScreen,
  Controls,
  PlaybackControl,
  VolumeControl,
  SettingsControl,
  ScrubberControl,
  Poster,
  DefaultSettings,
  ClickToPlay,
  FullscreenControl
} from '@vime/vue-next';
import '@/assets/css/default.css';

export default {
  name: "youtube-video",
  props: {
    videoId: String,
    type: String,
  },
  data() {
    return {
      primary_color: "#2a8bb1",
      logo: require("@/assets/images/logo.png"),
      isPiP: false,
      playerInstance: null,
    };
  },
  components: {
    Player,
    Youtube,
    Ui,
    Controls,
    PlaybackControl,
    VolumeControl,
    SettingsControl,
    ScrubberControl,
    Poster,
    DefaultSettings,
    ClickToPlay,
    LoadingScreen,
    FullscreenControl,
    VuePlyr
  },
  methods: {
    onPlayerReady(event) {
      // Access the YouTube player instance
      this.playerInstance = event.detail; // YouTube player instance
      this.setHDQuality();
    },
    setHDQuality() {
      if (this.playerInstance && this.playerInstance.setPlaybackQuality) {
        // Set the desired quality level, 'hd1080' for 1080p or 'hd720' for 720p
        this.playerInstance.setPlaybackQuality('hd1080');
      }
    }
  },
};
</script>

<style>
.plyr__controls {
  background: #111;
  border-radius: 12px;
}
/* Add any styles here */
</style>